<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="isShowCreateWorkDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="750px"
      :before-close="handleClose"
      :append-to-body="appendToBody"
    >
      <div class="main">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          size="small"
          :disabled="isNotEdit"
        >
          <el-form-item label="作业标题" prop="name">
            <el-input v-model="form.name" clearable maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="作业内容" required v-if="!isNotEdit">
            <v-editor
              v-if="isShowCreateWorkDialog"
              v-model="form.content"
              :onlyKey="onlyKey"
              ref="edit2"
              class="discuss_content"
            ></v-editor>
            <el-upload
              class="upload-demo"
              :action="importUrl"
              ref="uploadFile"
              :file-list="fileList2"
              accept="*.png"
              :limit="10"
              :on-progress="onProgress"
              :headers="headers"
              :before-upload="beforeAvatarUpload"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePreview"
              :on-error="onError"
              :on-exceed="handleExceed"
              multiple
              style="margin-top: 10px"
            >
              <el-button size="small" type="primary">添加附件</el-button>
              <!-- <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item label="作业内容" required v-if="isNotEdit">
            <div class="previewBox editorShowArea ql-editor" v-html="form.content"></div>
            <div class="previewAttachment">
              <span v-for="item in form.fileList" :key="item.id">
                {{ item.attachmentName }}
              </span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isNotEdit">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitFunc('form')" :disabled="!!isdisableds" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/work";
import vEditor from "@/components/wjlEditor/index.vue";
export default {
  name: "createWork",
  components: {
    vEditor,
  },
  props: {
    isShowCreateWorkDialog: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: "创建作业",
    },
    dialogData: {
      type: Object,
      default: () => {},
    },
    isNotEdit: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  watch: {
    dialogData: {
      handler(newVal) {
        this.form = {}
        if (Object.keys(newVal).length != 0) {
          console.log(newVal);
          // this.$nextTick(()=>{
            this.form = {
              id: newVal.id,
              name: newVal.name,
              content: newVal.homeworkContents[0].content,
              fileList: newVal.homeworkContents[0].attachment,
            };
            //   console.log(this.$refs['edit2'].init)
            // this.$refs['edit2'].init && this.$refs['edit2'].init()
          // })
          this.fileList = [];
            this.clearFile();
            if(!newVal.homeworkContents[0] ){
                return
            }
          [].forEach.call(newVal.homeworkContents[0].attachment, (item) => {
            this.fileList.push({
              id: item.id,
              name: item.attachmentName,
              originalAttaUrl: item.attachmentUrl,
              newType: item.type
            });

          });
            this.fileList2 = [...this.fileList]
        } else {
          this.form = {
            name: "",
            content: "",
            fileList: [],
          };
          this.fileList = [];
            this.clearFile()
        }
      },
      immediate: true,
      deep: true,
    },
      isShowCreateWorkDialog(){
        if(!this.isShowCreateWorkDialog){
            this.fileList = []
            this.clearFile()
        }
      }
  },
  data() {
    return {
      form: {
        name: "",
        content: "",
        fileList: [],
      },
      onlyKey: '123',
      rules: {
        name: [{ required: true, message: "请输入作业标题", trigger: "blur" }],
      },
      fileList: [],
      importUrl: "",
      proData: {},
      isdisableds: 0,
        fileList2: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$set(this.form, "name", "");
      this.$set(this.form, "content", "");
      this.$refs.form.resetFields();
      this.$emit("handleClose");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.form.fileList = []
      let url = file.originalAttaUrl;
      console.log(this.fileList, file);
      [].forEach.call(this.fileList, (item, i) => {
        if (item.originalAttaUrl === url || (file.response && file.response.data.originalAttaUrl === item.originalAttaUrl)) {
          this.fileList.splice(i, 1);
        }
      });
    },
      onProgress(p, file){
          // console.log(file)
          if(!file){
              return file
          }
          this.proData[file.name] = 1
          this.isdisableds = Object.keys(this.proData).length
      },
      onError(file){
          console.log(file)
      },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(file, attachment) {
        this.$message.warning(
            `最多能上传10个附件`);
    },
      clearFile(){
          this.$refs['uploadFile']? this.$refs['uploadFile'].clearFiles() : false
      },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
        return true
    },
    //添加素材上传 准备参数
    beforeAvatarUpload(file) {
        console.log('准备参数',file)
      let fileSize = file.size;
      let name = file.name;
      if (name.length > 200) {
        this.$message.warning("名字长度过长,请重新选择");
        this.isAbled = false;
        return false;
      }
      this.loading = true;
      let suffix = name.substring(name.lastIndexOf(".") + 1);
          console.log('-------------', suffix);
      let docArr = [
        "docx",
        "DOCX",
        "doc",
        "DOC",
        "ppt",
        "PPT",
        "pptx",
        "PPTX",
        "pdf",
        "PDF",
        "xlsx",
        "xls",
        "XLSX",
        "XLS",
      ];
      if (docArr.indexOf(suffix) != -1) {
        if (fileSize > 104857600) {
          //104857600 100M
          this.$message.warning("上传文件不能大于100M");
          this.isAbled = false;
          return false;
        }
        //上传类型 2 文档
        this.fileType = 2;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`;
            resolve();
          });
        });
      } else if (
        suffix == "mp4" ||
        suffix == "MP4" ||
        suffix == "asx" ||
        suffix == "ASX" ||
        suffix == "asf" ||
        suffix == "ASF" ||
        suffix == "mpg" ||
        suffix == "MPG" ||
        suffix == "3gp" ||
        suffix == "3GP" ||
        suffix == "mov" ||
        suffix == "MOV" ||
        suffix == "avi" ||
        suffix == "AVI" ||
        suffix == "flv" ||
        suffix == "FLV"
      ) {
        if (fileSize > 2147483648) {
          //2147483648 2G
          this.$message.warning("上传视频文件不能大于2G");
          this.isAbled = false;
          return false;
        }
        //上传类型 4  视频
        this.fileType = 4;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`;
            resolve();
          });
        });
        // return true;
      } else if (suffix == "mp3") {
        if (fileSize > 31457280) {
          //31457280 2G
          this.$message.warning("上传音频文件不能大于30M");
          this.isAbled = false;
          return false;
        }
        //上传类型 3  音频
        this.fileType = 3;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`;
            resolve();
          });
        });
      } else if (suffix == "jpg" || suffix == "png" || suffix == "jpeg") {
        if (fileSize > 10485760) {
          //104857600 10M
          this.$message.warning("上传图片不能大于10M");
          this.isAbled = false;
          return false;
        }
        //上传类型 1  图片
        this.fileType = 1;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`;
            resolve();
          });
        });
      } else if (suffix == "zip" || suffix == "rar") {
        if (fileSize > 104857600) {
          //104857600 100M
          this.$message.warning("上传压缩包不能大于100M");
          this.isAbled = false;
          return false;
        }
        this.fileType = 5;
        this.isAbled = true;
        // this.materialForm.upload.data.savepath = "course_res_/resourse/";
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`;
            resolve();
          });
        });
      } else {
        this.$message.error("上传文件格式错误");
        // this.isAbled = false;
        //   this.loading = false
        return false;
      }
    },
    // 文件上传成功时的钩子
    // handleAvatarSuccess(res,ind) {
    //     console.log(res,ind)
    //     if(res.code == 0){
    //         this.dtContent[ind].currentValue.push(res.data)
    //         this.$set(this.dtContent,ind,this.dtContent[ind])
    //     }
    // },
    //上传图片
    handleAvatarSuccess(res, fileList) {
      delete this.proData[fileList.name]
        this.isdisableds = Object.keys(this.proData).length
      if (res.code == 0) {
        // console.log(res.data, fileList);
        this.fileList.push(res.data)
        // let obj = {
        //   id: res.data.id,
        //   newAttaUrl: res.data.newAttaUrl,
        //   name: res.data.name,
        // };
        // this.form.fileList.push(obj);
      } else {
        this.$messageWarning(res.msg);
      }
    },
    submitFunc(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.form.content) {
            this.$message.warning("请输入作业内容");
            return;
          }
          let urlArr = [];
          [].forEach.call(this.fileList, (item) => {
            urlArr.push({
              attachmentUrl: item.originalAttaUrl,
              attachmentName: item.name,
              type: item.newType
            });
          });
          let params = {
            id: this.form.id ? this.form.id : "",
            name: this.form.name,
            // 课程里新建作业需要id
            courseId: this.courseId ? this.courseId
              : (this.$route.query.courseId
              ? this.$route.query.courseId
              : this.$route.query.id),
            classId: this.$route.query.classId,
            homeworkContent: [
              {
                content: this.form.content,
                attachment: urlArr,
              },
            ],
          };
          if (params.id) {
            api.workTemplateUpdate(params).then((res) => {
              if (res.code == "0") {
                this.$message.success(res.msg);
                  if(this.$parent.workTemplateSelect){
                      this.$parent.workTemplateSelect()
                  }
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            api.workTemplateCreate(params).then((res) => {
              if (res.code == "0") {
                this.$message.success(res.msg);
                if(this.$parent.workTemplateSelect){
                    this.$parent.workTemplateSelect()
                }
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.discuss_content {
  word-break: break-all;
  /deep/ .w-e-text-container {
    /*min-height: 120px !important;*/
    overflow: auto;
    /*height: auto !important;*/
    .w-e-text{
      line-height: 1.5;
      min-height: 120px !important;
    }
    .w-e-text p{
      line-height: 1.5;
    }
  }
}
.previewBox {
  background-color: #f5f5f7;
  padding: 10px;
}
.previewAttachment {
  display: flex;
  flex-wrap: wrap-reverse;
  span {
    background-color: #f5f5f7;
    padding: 5px;
    border-radius: 3px;
    margin-right: 5px;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/components/CreateWork.vue